import Hero from '../components/Hero';
import '../styles/Pages.css';

function BigData({ setCurrentPage }) {
    return (
      <>
      <Hero title="Big Data Solutions" image="/images/bigdata.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/bigdata.jpg" alt="Big Data" />
          </div>
          <div className="service-text">
            <h3>Big Data</h3>
            <p>
              Large information is the arrangement of innovations made to store, dissect and deal
              with this mass information, a full scale device made to distinguish designs in the
              bedlam of this blast in data to configuration shrewd arrangements. Today it is
              utilized in regions as different as medication, agribusiness, betting and ecological
              security.
            </p>
            <p>
              Big data refers to the suite of technologies developed to store, analyze, and manage
              massive amounts of information. These tools are designed to uncover patterns amidst
              the overwhelming surge of data, enabling the creation of intelligent solutions.
              Today, big data is applied across various fields, including medicine, agriculture,
              gambling, and environmental protection.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
        
          
          </div>
        </div>
      </div>
      </>
    );
  }
  
  export default BigData;